import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'

export const qanda = [
  {
    q: 'Schützen Masken vor Infektionen?',
    a: (
      <>
        Ein Team um den englischen Epidemiologen Tom Jefferson von der
        Universität Oxford hat im April{' '}
        <Link href='https://www.medrxiv.org/content/10.1101/2020.03.30.20047217v2'>
          14 Studien
        </Link>{' '}
        durchforstet, um endlich die Frage zu klären, wie gut Gesichtsmasken
        tatsächlich vor viralen Infektionen schützen. Das Resultat war für alle,
        die klare Antworten mochten, nicht allzu befriedigend: Jeffersons Team
        konnte keinen klaren Effekt finden, dass Masken die Infektionszahlen
        senken. Allenfalls in Kombination mit anderen Massnahmen könnten die
        Masken etwas bringen. In einem Interview mit dem Schweizer Fernsehen
        schlug Jefferson vor, man sollte die aktuelle Situation nützen, um mehr
        Studien zu dem Thema in Angriff zu nehmen. Ein{' '}
        <Link href='https://www.bmj.com/content/369/bmj.m1435'>Artikel</Link> im
        British Medical Journal, an dem auch der Schweizer Neonatologe Manuel
        Schmid mitgearbeitet hat, konnte auch nicht klar nachweisen, dass Masken
        vor einer Infektion mit dem Coronavirus schützen. Aber die Forscher
        kamen schon damals zum Schluss: «Weil Covid-19 eine so ernste Bedrohung
        ist, raten wir dazu in der Öffentlichkeit Masken zu tragen.» Denn selbst
        ein kleiner Effekt könnte Leben retten, sind die Wissenschaftler
        überzeugt. Auch ein britisch-chinesisches Team sprach sich im
        Fachmagazin{' '}
        <Link href='https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)30918-1/fulltext'>
          Lancet
        </Link>{' '}
        für das Maskentragen aus. Das Maskentragen bringe für den Einzelnen
        nicht viel, schrieben die Autoren, doch als Gesamtmassnahme, wenn sich
        alle daran halten würden, könnte es trotzdem helfen, die Epidemie
        einzudämmen.
        <br />
        <br />
        Mit dem Fortschreiten der Pandemie zeigen allerdings immer mehr Studien,
        dass sich durch das Tragen eines Mund-Nasen-Schutzes die Ausbreitung von
        Covid-19 verringern lässt. Auch die Weltgesundheitsorganisation (WHO)
        hat ihren Standpunkt zum Tragen von Gesichtsmasken in der Corona-Krise
        geändert. Zur Eindämmung von Infektionen empfiehlt sie nun das Tragen in
        überfüllten Einrichtungen, teilte die WHO am 6. Juni mit. Vorher galt,
        dass der Mundschutz nur für Kranke und Menschen, die Kranke pflegten,
        sinnvoll sei.
        <br />
        <br />
        Ein Überblick über aktuelle Ergebnisse aus Studien zur Wirksamkeit von
        Schutzmasken:
        <ul className='inlineList'>
          <li>
            <b>Experiment mit Hamstern (26.&nbsp;März&nbsp;2020)</b>
            <br />
            Eine{' '}
            <Link href='https://academic.oup.com/cid/advance-article/doi/10.1093/cid/ciaa325/5811871?searchresult=1'>
              Studie
            </Link>{' '}
            aus Hongkong hat in einem Tierexperiment mit Hamstern erstmals
            nachgewiesen, dass sich durch Mundschutzmasken das
            Übertragungsrisiko des Coronavirus deutlich verringern lässt. Dabei
            sank das Infektionsrisiko gesunder Hamster um mehr als 60 Prozent,
            wenn am Käfig infizierter Tiere ein Maskenstoff angebracht war.
            Hatten nur die gesunden Tiere einen Maskenschutz, halbierte es die
            Infektionsgefahr immerhin. Ohne jeglichen Schutz infizierten sich
            zwei Drittel der Tiere innert einer Woche.
          </li>
          <li>
            <b>
              Studie aus China und den USA zur Effektivität von Masken
              (27.&nbsp;Mai&nbsp;2020)
            </b>
            <br />
            In der im{' '}
            <Link href='https://science.sciencemag.org/content/early/2020/06/02/science.abc6197.1'>
              Fachmagazin Science
            </Link>{' '}
            erschienen Arbeit gehen die Forscher davon aus, dass sich das neue
            Coronavirus nicht nur durch Niesen, Husten und feuchtes Sprechen
            verbreiten kann, sondern auch über in der Luft schwebenden Aerosole.
            Dabei handelt es sich um besonders feinen virushaltigen Nebel, der
            schon beim normalen Atmen und Sprechen entsteht und lange in der
            Luft stehen bleiben kann. Masken stellen damit eine Barriere dar,
            welche die Anzahl infektiöser Viren beim Ausatmen von
            asymptomatischen Personen reduziert, so die Forscher. Im Bericht
            schreiben die Wissenschaftler anhand epidemiologischer Daten, dass
            Länder mit einer frühzeitig eingeführten Maskenpflicht - wie Taiwan,
            Singapur oder Südkorea - die Pandemie besonders gut eindämmen
            konnten. Zudem sei es vor allem wichtig, Masken an Orten zu tragen,
            an denen sich hohe Viruskonzentrationen ansammeln können, wie in
            öffentlichen Verkehrsmitteln, Restaurants oder anderen engen Räumen
            mit reduzierter Belüftung.
          </li>
          <li>
            <b>
              Studie chinesischer Forscher über den Nutzen von Masken in
              Haushalten (29.&nbsp;Mai&nbsp;2020)
            </b>
            <br />
            Eine im{' '}
            <Link href='https://gh.bmj.com/content/5/5/e002794' allowWordWrap>
              Fachmagazin BMJ Global Health
            </Link>{' '}
            veröffentlichte Studie aus China untersuchte 335 Menschen in 124
            Familien, bei denen mindestens eine Person positiv auf Covid-19
            getestet worden war. Laut den Forschern verringerte das Tragen einer
            Schutzmaske das Infektionsrisiko um 79% - jedoch nur, wenn die
            Familienmitglieder Masken trugen, bevor bei der ersten infizierten
            Person Symptome auftraten. Damit bestätigen sich Beobachtungen aus
            anderen Studien, dass die grösste Gefahr von Infizierten ausgeht,
            die noch keine Symptome zeigen.
          </li>
          <li>
            <b>
              Übersichtsstudie zur Effektivität verschiedener Schutzmassnahmen:
              Mindestabstand, Masken, Augenschutz (1.&nbsp;Juni&nbsp;2020)
            </b>
            <br />
            Ein Team aus Wissenschaftler hat im Auftrag der WHO insgesamt 44
            vergleichende Studien aus 16 Ländern systematisch analysiert, um die
            Wirksamkeit von Schutzmassnahmen gegen die Verbreitung von viralen
            Krankheiten wie Covid-19 zu überprüfen. Nach den Ergebnissen der
            Meta-Analyse kann ein Mund-Nasen-Schutz das Risiko einer Infektion
            um bis zu 80% senken. Ohne Mund-Nasen-Schutz betrug das
            Infektionsrisiko in den Studien 17,4%, mit Mundschutz fiel es auf
            3,1%. Somit schützt die Maske bis zu einem gewissen Grad auch ihren
            Träger vor einer Ansteckung. Obwohl die Autoren auf die geringe
            Evidenz der Ergebnisse hinweisen, lässt die{' '}
            <Link href='https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)31142-9/fulltext'>
              Übersichtsstudie
            </Link>{' '}
            auf eine positive Wirkung von Masken schliessen.
            <div className='relatedLinks'>
              Artikel zur Studie:
              <br />
              <Link
                href='https://www.tagesanzeiger.ch/die-maske-schuetzt-auch-ihre-traeger-332116277623'
                allowWordWrap
                style={{ fontSize: '1rem' }}
              >
                Die Maske schützt auch ihre Träger
              </Link>{' '}
            </div>
          </li>
        </ul>
      </>
    )
  },
  {
    q: 'Wie schützt die Maske mich?',
    a: (
      <>
        Besteht das Hauptziel darin, sich vor den Viren anderer zu schützen,
        bringen die einfachen Stoffmasken und Hygienemasken im Alltag wenig,
        denn sie riegeln Mund und Nase in der Regel nicht hermetisch ab. Diese
        Masken halten grössere Partikel ab, verfügen aber nicht über Filter, um
        vor Viren zu schützen. Denn die kugelförmigen Viren sind ungefähr
        1000-mal kleiner als die Breite eines Haares und passen so durch die
        Lücken zwischen den Fasern im Papier der Masken. Der Erreger kann beim
        Atmen durch die seitlichen Maskenöffnungen eingesaugt werden. Oder das
        Virus bleibt an Masken geringer Schutzklasse kleben und gelangt beim
        nächsten Atemzug in den Körper. Schützen können nur die spezialisierten
        N95-Masken, auch sie bieten zwar keine absolute Sicherheit, erreichen in
        Tests aber sehr hohe Werte. Die N95-Masken sind vorwiegend für das
        Gesundheitspersonal vorbehalten, das tagtäglich mit Infizierten zu tun
        hat, und sind nicht für die breite Bevölkerung gedacht. In den Medien
        werden oft FFP-Masken mit Ventil in der Mitte gezeigt. Das deutsche
        Bundesinstitut für Arzneimittel und Medizinprodukte (BfArM) stellt dazu
        fest: «Masken ohne Ventil filtern sowohl die eingeatmete Luft als auch
        die Ausatemluft und bieten daher sowohl Eigenschutz als auch
        Fremdschutz. Masken mit Ventil filtern nur die eingeatmete Luft und sind
        daher nicht für Fremdschutz ausgelegt.» Anstecken kann man sich zudem
        auch über Tröpfchen, die ins Auge gelangen. Aus diesem Grund trägt das
        Gesundheitspersonal auch Schutzbrillen.
      </>
    )
  },
  {
    q: 'Wie schützt die Maske die anderen?',
    a: (
      <>
        Das Tragen von einfachen Masken schützt vor allem andere vor mir.
        Deshalb hat der deutsche Virologe Christian Drosten es auch immer wieder
        als «Höflichkeitsgeste» bezeichnet, wenn man solche Masken in der
        Öffentlichkeit trägt. Wenn alle in der Öffentlichkeit Masken anziehen,
        gibt es zudem einen kollektiven Schutzeffekt für den Maskentragenden:
        Man ist geschützt, weil das Gegenüber, das vielleicht von seiner
        Infektion noch nichts weiss, ebenfalls eine Maske trägt. Es mehren sich
        die Hinweise, dass Infizierte schon ein, zwei Tage, bevor sie selbst
        erkranken, sehr ansteckend sind. In einer{' '}
        <Link href='https://www.nature.com/articles/s41591-020-0869-5#Fig1'>
          Studie
        </Link>{' '}
        aus China nehmen die Autoren an, dass 44 Prozent der Neuansteckungen
        passieren, bevor jemand Symptome zeigt. Wir wissen allgemein noch zu
        wenig über das Coronavirus und die Frage, wie es sich überträgt. Die
        Anzeichen verdichten sich, dass sich das neue Coronavirus nicht nur
        durch Niesen, Husten und feuchtes Sprechen, die Tröpfcheninfektion,
        verbreiten kann, sondern auch in Form eines Aerosols. Der Berliner
        Virologe Christian Drosten schätzt im{' '}
        <Link href='https://www.ndr.de/nachrichten/info/40-Jetzt-ist-Alltagsverstand-gefragt,audio681130.html'>
          NDR-Podcast
        </Link>{' '}
        , dass fast die Hälfte der Virusübertragungen auf Aerosole
        zurückzuführen sind, die andere Hälfte durch grössere Tröpfchen und nur
        rund zehn Prozent durch Schmier- oder Kontaktinfektionen. Diese Frage
        ist entscheidend, wenn es darum geht, wie wirksam einfache Masken sind.
        Aerosole sind winzigste Tröpfchen, die wir beim Sprechen verteilen.
        Stoffmasken und chirurgische Masken halten am ehesten die grösseren
        Tröpfchen, die wir beim Husten oder Niesen versprühen, zurück. Aerosole
        können sie nicht vollständig blockieren, dafür sitzen sie auch zu
        locker. Trotzdem können sie die Menge der versprühten Viren reduzieren.
        In einer Anfang April im Fachmagazin{' '}
        <Link href='https://www.nature.com/articles/s41591-020-0843-2'>
          «Nature Medicine»
        </Link>{' '}
        erschienenen Studie zeigten die Autoren, dass auch einfache Masken die
        Menge der Viren zumindest verringerten, die ein Infizierter verteilte.
        Beim Niesen oder Husten, ohne dass die Ellenbeuge vor den Mund gehalten
        wird, können Tröpfchen mit 180 km/h in die Umgebung geprustet werden und
        weiter fliegen als den Mindestabstand von 1,5 Metern. Auch wer sich eine
        einfache Maske umbindet, verhindert damit, dass sich die Viren
        ungebremst weiterverbreiten.
      </>
    )
  },
  {
    q: 'Warum rät das BAG immer noch von Masken ab?',
    a: (
      <>
        Masken böten «keinen wirklichen Schutz vor Viren», sagte Daniel Koch vom
        Bundesamt für Gesundheit (BAG) immer wieder. Auf der{' '}
        <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov/faq-kontakte-downloads/haeufig-gestellte-fragen.html?faq-url=/de/masken/sollen-alle-der-%C3%B6ffentlichkeit-eine-maske-tragen'>
          BAG-Website
        </Link>{' '}
        heisst es sogar immer noch explizit: «Gesunde Personen sollen in der
        Öffentlichkeit keine Hygienemasken tragen.» Sie würden nicht effektiv
        vor einer Ansteckung schützen. Dennoch gilt ab dem 6. Juli im
        öffentlichen Verkehr eine Maskenpflicht. Das hat der Bundesrat am 1.
        Juli beschlossen. Fürs Einkaufen hält der Bundesrat die Masken weiterhin
        für unnötig, solange der Abstand eingehalten wird.
      </>
    )
  },
  {
    q: 'Was empfehlen andere Behörden?',
    a: (
      <>
        Auch die US-amerikanische Seuchenbehörde CDC und das deutsche
        Robert-Koch-Institut (RKI) rieten zu Beginn von einer breiten
        Maskenempfehlung für die Bevölkerung ab. Nun sind beide umgeschwenkt:
        Das Tragen von nicht medizinischen (auch selbst gebastelten) Stoffmasken
        sei überall dort empfehlenswert, wo in der Öffentlichkeit Distanzhalten
        nur schwer möglich ist – beispielsweise in Supermärkten und Apotheken.
        Auch das RKI korrigiert seinen Kurs und rät nun, bei
        Erkältungskrankheiten präventiv eine Maske zu tragen, um andere etwa
        durch Niesen nicht zu gefährden – und in bestimmten Situationen im
        öffentlichen Raum, also beispielsweise im öffentlichen Verkehr. Wichtig
        sei jedoch, dass man mit der Maske richtig umgehe. Seit Ende April wurde
        in allen Bundesländern der einfache Mund-Nasen-Schutz in
        unterschiedlichem Ausmass beispielsweise in Supermärkten oder dem
        öffentlichen Personenverkehr zur Pflicht. Auch die
        Weltgesundheitsorganisation (WHO){' '}
        <Link href='https://www.who.int/publications-detail/advice-on-the-use-of-masks-in-the-community-during-home-care-and-in-healthcare-settings-in-the-context-of-the-novel-coronavirus-(2019-ncov)-outbreak'>
          erklärte
        </Link>{' '}
        erst am 6. April, Masken könnten tatsächlich einen Beitrag leisten, um
        die Verbreitung des Virus Sars-CoV-2 zu hemmen. Anfang Juni änderte die
        WHO dann ihre Leitlinien, nachdem eine Metaanalyse im Fachjournal{' '}
        <Link href='https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)31142-9/fulltext'>
          «The Lancet»
        </Link>{' '}
        gezeigt hatte, dass das Tragen von Schutzmasken die Ausbreitung von
        Covid-19 reduzieren kann. Neu empfiehlt die WHO, überall dort eine Maske
        zu tragen, wo man nicht Distanz halten kann.
      </>
    )
  },
  {
    q: 'Was empfiehlt ein südkoreanischer Epidemiologe der Schweiz?',
    a: (
      <>
        Der Aufruf erfolgt 9000 Kilometer weit weg von hier. Alle Bewohner der
        Schweiz sollen im Kampf gegen die Ausbreitung von Covid-19-Schutzmasken
        tragen, gleich wie in Südkorea. Das empfiehlt der Epidemiologe Chun
        Byung-chul in einem Schreiben an einen Schweizer Arzt. Der Experte von
        der Korea University lebt selber in Südkorea – das als jenes Land gilt,
        das die Verbreitung des Virus eingedämmt hat, ohne das ganze öffentliche
        Leben einzufrieren. Bei Covid-19, so Chun, seien die ersten Symptome
        sehr mild, sodass kaum zu erkennen sei, wer sich angesteckt habe und wer
        nicht. «Masken können die Ausbreitung der Tröpfchen, die das Virus
        enthalten, verringern.» Es gebe zwar keine Studien, die einen
        epidemiologischen Effekt der normalen Hygienemasken belegen würden, aber
        in der klinischen Praxis werde ein solcher Effekt doch festgestellt.
        Chuns Worte richten sich auch an den Bundesrat, wie er auf Anfrage
        präzisiert. Auch George Gao, Virologe und Direktor des chinesischen
        Zentrums für die Kontrolle und Prävention von Krankheiten, warnte in der
        Fachzeitschrift{' '}
        <Link href='https://www.sciencemag.org/news/2020/03/not-wearing-masks-protect-against-coronavirus-big-mistake-top-chinese-scientist-says'>
          «Science»
        </Link>{' '}
        vor einer verpassten Chance: «Die USA und Europa machen einen grossen
        Fehler, indem die Menschen dort keine Masken tragen. Viele Personen
        haben eine asymptomatische oder präsymptomatische Infektion. Wenn sie
        eine Maske tragen würden, könnte diese verhindern, dass Tröpfchen, die
        das Virus übertragen, entweichen und andere infizieren.» Viele
        europäische Länder folgten diesem Rat schon. In <b>Tschechien</b> durfte
        vor den Lockerungen ende Mai niemand mehr ohne Mund- und Nasenbedeckung
        das Haus verlassen. In <b>Deutschland</b> haben alle Bundesländer eine
        Maskenpflicht beschlossen, die weiterhin zu den Basismassnahmen zählt.
        Kanzlerin Angela Merkel hatte das Tragen sogenannter Hygienemasken in
        Bussen und Bahnen sowie im Einzelhandel lediglich «dringend empfohlen».{' '}
        <b>Österreich</b> hatte bis mitte Juni eine der umfassendsten
        Maskenpflicht innerhalb der EU. Sie galt in allen Geschäften,
        Supermärkten, Restaurants oder sogar in der Öffentlichkeit, wenn Bürger
        mit anderen Menschen in Kontakt traten. Seit den Lockerungen am 15. Juni
        müssen Österreicher(innen) nur noch im öffentlichen Verkehr, im
        Gesundheitsbereich sowie bei Dienstleistungen, bei denen die
        Abstandsregeln nicht eingehalten werden können, zur Maske greifen.
      </>
    )
  },
  {
    q:
      'Welche Branchen haben in der Schweiz eine Maskenpflicht für Angestellte?',
    a: (
      <>
        Pflicht ist das Tragen von Masken in der Schweiz bei einigen neu wieder
        zugelassenen Dienstleistungen, bei denen sich Kunde und Dienstleister
        näher als 1,5 Meter kommen. Im Gesundheitsbereich sind dies etwa{' '}
        <b>Physiotherapie- oder Massagepraxen</b>. Um Personal und Kundschaft
        besser zu schützen haben auch <b>Coiffeurgeschäfte</b>,{' '}
        <b>Kosmetikinstitute</b> oder <b>Tattoo-Studios</b> die obligatorische
        Nutzung von Masken als einheitliche Branchenlösung eingeführt. Die
        Geschäfte können die Masken über eine Branchenplattform bestellen.
        Ebenso hat der Schweizerische <b>Fahrlehrerverband</b> eine generelle
        Tragpflicht einer Schutzmaske für Fahrschüler(innen) bestimmt. Das
        Schutzkonzept der <b>Swiss Retail Federation</b>,{' '}dem Verband der
        mittelständischen Detailhandelsunternehmen, schreibt keine
        Maskentragpflicht für Angestellte vor. Falls Mitarbeitende es wünschen,
        sollen Masken jedoch zur Verfügung gestellt werden. Ähnlich sieht es bei{' '}
        <b>Hoteliers und Gastronomen</b>{' '}aus, hier sind Masken nur in besonderen
        Arbeitssituationen angedacht.
      </>
    )
  },
  {
    q: 'Wie sieht das Schutzkonzept der SBB aus?',
    a: (
      <>
        Mit den Lockerungen am 11. Mai hat auch der öffentliche Verkehr sein
        Fahrplanangebot wieder erhöht. Begleitet wird der Schritt mit einem
        Schutzkonzept, welches die Schweizer Transportunternehmen in
        Zusammenarbeit mit den Bundesämtern für Verkehr und Gesundheit
        erarbeitet haben. Dabei wird vor allem auf die Selbstverantwortung und
        Solidarität der Reisenden gesetzt. Das Schutzkonzept beinhaltet folgende
        Grundsätze:
        <ul>
          <li>Stosszeiten vermeiden</li>
          <li>Abstandsregeln einhalten</li>
          <li>Hygieneregeln beachten</li>
          <li>Tickets wenn möglich online oder am Automaten kaufen</li>
        </ul>
        Zusätzlich hat man mehr Desinfektionspunkte an Bahnhöfen eingerichtet
        und die Reinigung, insbesondere von Kontaktflächen, stark intensiviert.{' '}
        <b>
          Ab Montag, 6. Juli gilt im öffentlichen Verkehr eine Maskenpflicht.
          Dies hat der Bundesrat am 1. Juli schweizweit beschlossen.
        </b>
      </>
    )
  },
  {
    q: 'Kann ich eine Maske wiederverwenden?',
    a: (
      <>
        Eigentlich galt bis vor der Epidemie die klare Empfehlung, Hygienemasken
        nicht zweimal zu verwenden und die Maske, sobald sie zu feucht wird, zu
        ersetzen. Doch in Zeiten, wo alles medizinische Equipment grundsätzlich
        knapp ist, gelten andere Regeln. Im Hinblick auf einfache Hygiene- oder
        Stoffmasken zeigt sich der Virologe Christian Drosten von der Berliner
        Charité zuversichtlich, dass es ausreicht, sie bei 70 Grad in den
        Backofen zu legen, bis sie trocken sind. So könne man sie auch zweimal
        verwenden, aber immer nur für sich selbst. Stoffmasken seien zudem bei
        60 Grad waschbar. Bei der Handhabung der Masken müsse man zudem
        aufpassen die Vorderseite, auf der sich die meisten Viren befinden,
        nicht anzufassen. Mit Desinfektionsmitteln darf man Hygienemasken nicht
        reinigen, weil das die Maske schädigt. Das Bundesamt für Gesundheit rät
        allerding von einer Wiederverwendung ab: «Wenn Sie die Maske getragen
        haben, ist die Oberfläche potenziell kontaminiert. Deshalb können Sie
        sie nicht wieder verwenden. Sobald Sie die Maske abnehmen, müssen Sie
        sie korrekt in einem Mülleimer entsorgen.»
      </>
    )
  },
  {
    q: 'Kann ich Schutzmasken in der Mikrowelle sterilisieren?',
    a: (
      <>
        Nein. Um die Stoffmasken zu reinigen, sollte man sie in der
        Waschmaschine waschen, möglichst bei 60 Grad. In den USA ist es bereits
        zu Bränden gekommen, weil Menschen ihre Masken, die ein Metallteil als
        Nasenbügel hatten, in der Mikrowelle zu sterilisieren versuchten.
      </>
    )
  },
  {
    q: 'Was taugen Stoffmasken (selbst gemachte)?',
    a: (
      <>
        Sie sollten möglichst aus Baumwollstoff sein, damit man sie heiss
        waschen kann, und mehrlagig. Stoffmasken bieten keinen Schutz vor einer
        Ansteckung für den Träger. Aber sie schützen andere, bis zu einem
        gewissen Grad, vor einem selbst. Noch grösser ist die Unsicherheit bei
        selbst genähten Masken, da diese nicht geprüft sind. «Die Schutzwirkung
        dieser Masken ist nicht belegt, sie können aber als optisches Signal
        dazu beitragen, dass die Abstandsregeln eingehalten werden und dass sich
        der Träger weniger ins Gesicht fasst», sagt Lukas Jaggi, Sprecher des
        Schweizerischen Heilmittelinstituts Swissmedic. Vom Tragen selbst
        hergestellter Gesichtsmasken aus Textil rät das Bundesamt für Gesundheit
        (BAG) explizit ab. Selbst genähte Masken böten keinen Schutz vor einer
        Ansteckung oder erhöhten sogar das Risiko.
      </>
    )
  },
  {
    q: 'Kann ich mir auch einen Schal um das Gesicht wickeln?',
    a: (
      <>
        Der Schal muss ähnlich eng wie eine Maske sitzen, dann gilt ungefähr das
        Gleiche in puncto Wirksamkeit wie bei einer selbst gemachten Maske aus
        Stoff: ein gewisser Schutz für die anderen; Eigenschutz nur, wenn es
        alle tun. Solche Stoffe können zwar einen gewissen Schutz bieten. Sie
        stellen eine Barriere dar, die verhindert, dass eigene Sekrettröpfchen
        mit Wucht in die Umgebung geschleudert werden. Auch Erreger von aussen
        gelangen auf diese Weise nicht ungehindert in Mund und Nase. Allerdings
        warnen Fachleute vor unsachgemässem Gebrauch.
      </>
    )
  },
  {
    q: 'Was ist das Risiko beim Tragen einer Maske?',
    a: (
      <>
        Eine Maske befreit einen nicht von den üblichen Regeln während dieser
        Pandemie. Man sollte sich nicht in falscher Sicherheit wiegen, auch mit
        Maske sind Social Distancing und Händewaschen noch genauso wichtig. Eine
        Maske kann jedoch dabei helfen, dass man sich weniger ins Gesicht fasst.
        Die Maske oder «eine andere Form der Barriere» könnte laut
        Robert-Koch-Institut dazu führen, «dass die Abstandsregel nicht mehr
        eingehalten oder die Händehygiene nicht mehr umgesetzt wird». Ansonsten
        sagen die Experten: Bis die Frage, ob sie tatsächlich auch beim neuen
        Coronavirus einen effektiven Schutz bieten, geklärt ist, gilt das
        Prinzip «Selbst wenn es nichts nützt, schadet es auch nicht». Adrien
        Burch, Mikrobiologin an der University of California in Berkeley,
        plädiert deshalb ebenfalls für das Tragen von Masken. Diese würden viel
        mehr helfen als schaden, schreibt sie in einem{' '}
        <Link href='https://www.sciencemag.org/news/2020/03/not-wearing-masks-protect-against-coronavirus-big-mistake-top-chinese-scientist-says'>
          Blog-Eintrag
        </Link>
        . Bei Sars, mit dem das aktuelle Virus Sars-CoV-2 verwandt ist, hätten
        sie einen signifikanten Schutz geboten – und zwar sowohl als einfache
        Hygienemasken als auch als Atemschutzmasken.
      </>
    )
  },
  {
    q: 'Muss ich beim Joggen eine Maske tragen?',
    a: (
      <>
        Auch beim Joggen gelten die Distanzregeln, also sollte man möglichst
        dort laufen gehen, wo es wenige Menschen gibt, und die normalen
        Abstandsregeln einhalten. Dann gibt es auch keinen Grund, eine Maske zu
        tragen, die das Laufen zudem erschweren könnte. Als Vorsichtsmassnahme
        gilt, dass man vor allem nicht zu nahe hinter einem anderen Läufer
        rennen sollte, also besser neben- als hintereinander joggen.
      </>
    )
  },
  {
    q: 'Sollen Kinder eine Maske tragen?',
    a: (
      <>
        Kinder unter 2 Jahren sollen grundsätzlich keine Masken tragen. Für
        Kindergarten- und Schulkinder kann es in gewissen Situationen in der
        Öffentlichkeit oder im Kontakt mit Risikogruppen Sinn machen. Allerdings
        ist es für kleinere Kinder schwieriger, sich an die Regeln des korrekten
        Maskengebrauchs zu halten. Gesunde Kinder untereinander brauchen keine
        Masken, weil sie selbst praktisch nie schwer erkranken an Covid-19.
      </>
    )
  },
  {
    q: 'Soll man zu Hause eine Maske tragen?',
    a: (
      <>
        Zuhause macht es dann Sinn, wenn man selbst krank ist und man seine
        Mitbewohner so vor einer Ansteckung schützen möchte. Helfen kann eine
        Maske zu Hause auch dann, wenn man mit jemandem zusammenlebt, der zur
        Risikogruppe gehört. Man kann das Risiko einer Ansteckung für diesen
        Menschen senken, indem man selbst eine Maske trägt.
      </>
    )
  },
  {
    q: 'Was sollen Brillenträger beim Tragen von Masken beachten?',
    a: (
      <>
        Die Brille sollte auf der Maske getragen werden, sodass der Stoff
        unterhalb des Brillengestells liegt. Einerseits sitzt die Maske dadurch
        besser, andererseits kann die warme Atemluft mit etwas mehr Abstand an
        den Gläsern vorbeifliessen und so ein Beschlagen vermindern. Direkt
        unter der Brille sollte die Maske möglichst eng anliegen. Biegbare
        Metallbügel helfen hier, den Stoff eng an die Nasenform anzupassen. Die
        Luft entweicht somit nicht mehr so einfach nach oben weg. In vielen
        Teilen Asiens hat sich zudem der einfache Trick etabliert, die obere
        Kante von Einwegmasken nach innen zu falten. Dabei ist es aber wichtig,
        dass trotz des Faltens, Nase und Kinn vollständig bedeckt bleiben.
      </>
    )
  }
]
